import React, { Component } from 'react';
import { Modal, Spin, Icon, Button, Tag, message } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import deepClone from '../../../shared/deepClone';
import $ from 'jquery';

let canBABatchTransferBa = false;

class TransferCompany extends Component {
    state = {
        data: {},
        visible: false,
        companyList: [],
    }

    show = (index, record) => {
        const { companyList } = this.props;
        const { recipients, ...rest } = record;

        const companysCollect = [];
        (recipients || []).forEach((i, idx) => idx !== index && companysCollect.push(...(i.companys || [])));
        const newCompanyList = companyList.filter(i => !companysCollect.find(c => c.customerCompanyId == i.customerCompanyId));

        const data = deepClone({ index, ...rest, recipient: recipients[index] });
        this.setState({
            data,
            visible: true,
            companyList: newCompanyList,
        });
    }

    hide = () => {
        this.setState({ visible: false, selectedIndex: undefined }, () => {
            $('.tableC .transferCompany .ant-table-body').scrollTop(0);
        });
    }

    handleChange = ({ value, text }) => {
        const { data } = this.state;
        data.companyId = value;
        data.companyName = text;
        this.setState({
            data,
            selectedIndex: undefined,
        });
    }

    handleSearch = () => {
        const { data, companyList } = this.state;
        const { companyId } = data;
        const index = companyList.findIndex(i => i.customerCompanyId == companyId);
        if (~index) {
            const body = $('.tableC .transferCompany .ant-table-body');
            const position = body.find('tbody.ant-table-tbody tr').eq(index).position();
            body.scrollTop(position.top);
        } else {
            message.warning('待交接的客户列表中不存在此客户！');
        }
        this.setState({ selectedIndex: index });
    }

    getColumns = () => [{
        title: '客户名称',
        dataIndex: 'customerCompanyName',
        key: 'customerCompanyName',
    }]

    onSelectChange = (record, selected) => {
        const { data } = this.state;
        const { recipient } = data;
        const companys = recipient.companys || (recipient.companys = []);
        if (selected) {
            companys.push({...record});
        } else {
            const index = companys.findIndex(i => i.customerCompanyId == record.customerCompanyId);
            if (~index) {
                companys.splice(index, 1);
            }
        }
        this.setState({ data });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { data } = this.state;
        const { recipient } = data;
        if (selected) {
            recipient.companys = selectedRows;
        } else {
            recipient.companys = [];
        }
        this.setState({ data });
    }

    submit = () => {
        const { data } = this.state;
        const { index, recipient } = data;
        const { companys } = recipient;
        if (!(companys || []).length) {
            message.warning('请选择需要交接的客户！');
            return;
        }
        this.hide();
        this.props.saveTransferCompany(index, companys);
    }

    render() {
        const { visible, data, companyList, selectedIndex } = this.state;
        const { baUserId, baUserName, companyId, companyName, recipient } = data;
        const { userName, companys } = recipient || {};
        const selectedRowKeys = [];
        (companyList || []).forEach((item, index) => {
            if ((companys || []).find(c => c.customerCompanyId == item.customerCompanyId)) {
                selectedRowKeys.push(index + 1);
            }
        });
        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
        };
        let url = canBABatchTransferBa ?API_URL.contract.queryCustomerCompanyByBaUserId:API_URL.contract.queryCustomerCompanyByCsaUserId;
        return (
            <Modal
                title={`选择交接给此${canBABatchTransferBa?`BA`:`CSA`}的客户`}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
                width="600px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>{`交接前${canBABatchTransferBa?`BA`:`CSA`}:`}</div>
                            <div className="item-right" style={{ width: '70%' }}>{baUserName}</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>{`交接后${canBABatchTransferBa?`BA`:`CSA`}:`}</div>
                            <div className="item-right" style={{ width: '70%' }}>{userName}</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>{`交接给此${canBABatchTransferBa?`BA`:`CSA`}的客户:`}</div>
                            <div className="item-right" style={{ width: '70%' }}>
                                <div style={{marginBottom: 10}}>
                                    <SearchRetrieve
                                        keyword='keyword'
                                        style={{ width: 240 }}
                                        placeholder="输入客户名称检索"
                                        value={companyName}
                                        params={{ limit: 20, baUserId }}
                                        url={url}
                                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                        onChange={option => this.handleChange(option)}
                                    />
                                    <Button style={{marginLeft: 10}} type="primary" disabled={!companyId} onClick={this.handleSearch}>搜索</Button>
                                </div>
                                <TableC
                                    scrollY={220}
                                    data={companyList}
                                    className="transferCompany"
                                    rowSelection={rowSelection}
                                    columns={this.getColumns()}
                                    rowClassName={(record, index) => index === selectedIndex ? "light-blue-bkg" : ''}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

class BatchTransferBa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            visible: false,
            loading: false,
            companyList: [],
            shouldAddTransfer: false,
        };
    }

    getUserInfoDetail = userId => {
        Fetch.post(API_URL.user.getUserInfoDetail, {
            userId
        }).then(res => {
            const { employee: { userId, employeeName, employeeCode } = {} } = res;

            this.setState({
                data: {
                    baUserId: userId,
                    baUserName: `${employeeName}[${employeeCode}]`,
                }
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    loadData = () => {
        const { data } = this.state;
        const { baUserId } = data;
        let url = canBABatchTransferBa ?API_URL.contract.queryCustomerCompanyByBaUserId:API_URL.contract.queryCustomerCompanyByCsaUserId;
        if (baUserId) {
            this.setState({ loading: true });
            Fetch.post(url, {
                baUserId,
                isFirstClick: this.isFirstClick
            }).then(res => {
                const { data } = res;
                this.isFirstClick = undefined;
                this.setState({
                    companyList: data,
                    loading: false,
                }, () => {
                    this.shouldAddTransfer();
                });
            }).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            });
        } else {
            this.setState({
                companyList: [],
            }, () => {
                this.shouldAddTransfer();
            });
        }
    }

    show = (defaultData, bool) => {
        const { userId, userName, curRole } = sessionStorage;
        canBABatchTransferBa = bool;
        if (curRole === 'BA' && !canBABatchTransferBa) {
            this.isFirstClick = 1;
            this.selectBaDisabled = true;
            this.setState({
                data: defaultData || {
                    baUserId: userId
                },
                visible: true,
            }, () => {
                this.getUserInfoDetail(userId);
                this.loadData();
            });
        } else {
            this.setState({
                data: {},
                visible: true,
            }); 
        }
    }

    hide = () => {
        this.setState({ visible: false });
    }

    shouldAddTransfer = () => {
        const { data, companyList } = this.state;
        const { recipients } = data;

        const companysCollect = [];
        (recipients || []).forEach(i => companysCollect.push(...(i.companys || [])));
        const shouldAddTransfer = companysCollect.length !== companyList.length;

        this.setState({ shouldAddTransfer });
    }

    handleChange = ({ value, text }) => {
        const { data } = this.state;
        data.baUserId = value;
        data.baUserName = text;
        data.recipients = [];
        this.setState({ data }, () => {
            this.loadData();
        });
    }

    handleAdd = () => {
        const { data } = this.state;
        const recipients = data.recipients || (data.recipients = []);
        recipients.push({});
        this.setState({ data });
    }

    handleUserChange = (option, index) => {
        const { data } = this.state;
        const { recipients } = data;
        const { value, text } = option;
        recipients[index].userId = value;
        recipients[index].userName = text;
        this.setState({ data });
    }

    deleteUser = (index) => {
        const { data } = this.state;
        const { recipients } = data;
        recipients.splice(index, 1);
        this.setState({ data }, () => {
            this.shouldAddTransfer();
        });
    }

    deleteCompany = (index, cIndex) => {
        const { data } = this.state;
        const { recipients } = data;
        recipients[index].companys.splice(cIndex, 1);
        this.setState({ data }, () => {
            this.shouldAddTransfer();
        });
    }

    getContent = () => {
        const { data } = this.state;
        const { baUserId, recipients } = data;
        return (
            (recipients || []).map((item, index, array) => {
                const { userId, userName, companys } = item;
                const noUserId = array.map(item => item.userId).filter(i => !!i).concat(baUserId).join(',');
                const len = (companys || []).length;
                return (
                    <div key={index} style={{marginBottom: 12}}>
                        <div>
                            {
                                len ?
                                    <p style={{ display: 'inline-block', padding: '0 10px', width: 140, lineHeight: '28px', background: '#DDD', borderRadius: 4 }}>{userName}</p>
                                :
                                    <SearchRetrieve
                                        keyword='keyWord'
                                        style={{ width: 140 }}
                                        placeholder="输入姓名/工号检索"
                                        value={userName}
                                        params={{ limit: 20, roleCodes: canBABatchTransferBa ? 'BA,BAL':'CSA,CSAL' }}
                                        url={API_URL.execute.queryEmpListByRoleCode}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={option => this.handleUserChange(option, index)}
                                    />
                            }
                            <Icon type="close" style={{ marginLeft: 8, color: '#F00', cursor: 'pointer' }} onClick={() => this.deleteUser(index)} />
                            { userId && <a style={{ marginLeft: 8 }} onClick={() => this.transferCompany(index)}>选择交接给此{canBABatchTransferBa?'BA':'CSA'}的客户</a> }
                        </div>
                        <div style={{ marginTop: 4, maxHeight: 200, overflowY: 'auto', background: '#F6F6F6', borderRadius: 4 }}>
                            {
                                (companys || []).map((cItem, cIndex) => {
                                    const { customerCompanyName } = cItem;
                                    return (
                                        <div key={cItem.customerCompanyId} style={{margin: 4}}>
                                            <Tag closable color="#DDD" className="close-color" style={{color: 'rgba(0, 0, 0, .65)'}} onClose={() => this.deleteCompany(index, cIndex)}>{customerCompanyName}</Tag>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                );
            })
        );
    }

    submit = () => {
        const { data, companyList } = this.state;
        const { baUserId, recipients } = data;

        let index = -1;
        const params = {};
        if (!baUserId) {
            message.warning('请选择CSA！');
            return;
        }
        if (!companyList.length && this.selectBaDisabled) {
            message.warning('当前没有你负责的客户，无需发起批量交接！');
            return;
        }
        params.userId =  baUserId;
        for (let { userId, companys } of recipients) {
            if (userId && (companys || []).length) {
                index++;
                params[`baHandOvers[${index}].handOverUserId`] = userId;
                params[`baHandOvers[${index}].customerCompanyIdList`] = companys.map(i => i.customerCompanyId).join(',');
            }
        }
        if (!~index) {
            message.warning('请选择接收人或需要交接的客户！');
            return;
        }

        let url;
        if(canBABatchTransferBa){
            url = API_URL.contract.handoverCustomerBaList;
        }else{
            url = this.selectBaDisabled ? API_URL.contract.createHandoverBaUserList : API_URL.contract.handoverBaUserList;
        }
        this.setState({ loading: true });
        Fetch.post(url, params).then(() => {
            message.success('批量交接成功');
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    transferCompany = (index) => {
        const { data } = this.state;
        this.transferCompanyRef.show(index, data);
    }

    saveTransferCompany = (index, companys) => {
        const { data } = this.state;
        const { recipients } = data;
        recipients[index].companys = companys;
        this.setState({ data }, () => {
            this.shouldAddTransfer();
        });
    }

    render() {
        const { visible, loading, data, companyList, shouldAddTransfer } = this.state;
        const { baUserId, baUserName } = data;
        return (
            <Modal
                title="批量交接"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                width="500px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                {canBABatchTransferBa?
                                <div className="item-left" style={{ width: '30%' }}>{this.selectBaDisabled ? '交接BA' : '选择BA'}:</div>
                                :
                                <div className="item-left" style={{ width: '30%' }}>{this.selectBaDisabled ? '交接CSA' : '选择CSA'}:</div>
                                }
                                {
                                canBABatchTransferBa?
                                <div className="item-right" style={{ width: '70%' }}>
                                    <SearchRetrieve
                                        keyword='keyWord'
                                        style={{ width: 140 }}
                                        placeholder="输入姓名/工号检索"
                                        value={baUserName}
                                        params={{ limit: 20, roleCodes: 'BA,BAL' }}
                                        disabled={this.selectBaDisabled}
                                        url={API_URL.execute.queryEmpListByRoleCode}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={option => this.handleChange(option, 'ba')}
                                    />
                                </div>
                                :
                                <div className="item-right" style={{ width: '70%' }}>
                                    <SearchRetrieve
                                        keyword='keyWord'
                                        style={{ width: 140 }}
                                        placeholder="输入姓名/工号检索"
                                        value={baUserName}
                                        params={{ limit: 20, roleCodes: 'CSA,CSAL' }}
                                        disabled={this.selectBaDisabled}
                                        url={API_URL.execute.queryEmpListByRoleCode}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={option => this.handleChange(option, 'ba')}
                                    />
                                </div>
                                }   
                            </li>
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '30%' }}>选择接收人:</div>
                                <div className="item-right" style={{ width: '70%' }}>
                                    { this.getContent() }
                                    { baUserId && <Button type="primary" disabled={!shouldAddTransfer} onClick={this.handleAdd}>添加接收人</Button> }
                                </div>
                            </li>
                        </ul>
                        <TransferCompany ref={el => this.transferCompanyRef = el} companyList={companyList} saveTransferCompany={this.saveTransferCompany} />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default BatchTransferBa;



// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/BatchTransferBa.js